import React, { useState, useCallback } from 'react';
import ApplicationButtons from './Components/shared/applicationButtons';
import CompetenceScoreExplanation from './Components/shared/scoreExplanation';
import QuestionsAndAnswers from './Components/shared/questionsAndAnswers';
import { QuestionType } from './Helpers/enums';
import QuestionnaireDisplay from './Components/shared/QuestionnaireDisplay';
import { getRadialBarClass } from './Services/utils';
import { Row, Col, Collapse } from 'reactstrap';

const ApplicationDisplay = ({ application, t, refreshData, downloadCv, i18nLanguage, updateQuestionRating }) => {
  const updateQuestionRatingWithValidations = (rate, questionId, answerId) => {
    updateQuestionRating(rate, questionId, answerId);
  };

  const [accordionState, setAccordionState] = useState([true, true, true, true]);

  const toggleAccordion = useCallback((index) => {
    setAccordionState((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  }, []);

  return (
    <div>
      {/* Updated header with two groups aligned left and right */}
      <div className="d-flex justify-content-between mt-4">
        <div className="d-flex align-items-center">
          {application?.score?.fullScorePercentage ? (
            <span
              data-label={application?.score?.fullScorePercentage}
              className={getRadialBarClass(application?.score?.fullScorePercentage, 'sm') + ' mr-2'}
            />
          ) : null}
          <h2 className="mt-2">{application.job ? application.job.title : t('jobs.JOB_DUMMY')}</h2>
        </div>
        <div className="d-flex align-items-center">
          {application.cv?.url && (
            <span
              className="icon-link-effect mr-2"
              onClick={() => {
                downloadCv(application.cv.url, application.applicant.firstName, application.applicant.lastName, t);
              }}
            >
              <i className="fa-2x fas fa-file-text mx-1"></i>
              <strong style={{ fontSize: '20px' }}>CV</strong>
            </span>
          )}
          <ApplicationButtons application={application} onStatusRefresh={refreshData} btnSize="lg" />
        </div>
      </div>
      {application.applicant?.introduction && (
        <>
          <Row className="mt-4" onClick={() => toggleAccordion(0)} style={{ cursor: 'pointer' }}>
            <Col>
              <h3>
                <small>
                  <em
                    className={accordionState[0] ? 'fa fa-minus text-primary mr-2' : 'fa fa-plus text-primary mr-2'}
                  />
                </small>
                {t('common.INTRODUCTION')}
              </h3>
            </Col>
          </Row>
          <Collapse isOpen={accordionState[0]}>
            <Row>
              <Col>{application.applicant?.introduction}</Col>
            </Row>
          </Collapse>
        </>
      )}
      <CompetenceScoreExplanation
        i18nLanguage={i18nLanguage}
        application={application}
        isOpen={accordionState[1]}
        toggleAccordion={() => toggleAccordion(1)}
      />
      <QuestionsAndAnswers
        questions={application.answers.filter((x) => x.questionType === QuestionType.Normal)}
        updateQuestionRating={updateQuestionRatingWithValidations}
        isOpen={accordionState[2]}
        toggleAccordion={() => toggleAccordion(2)}
      />
      <QuestionnaireDisplay
        questions={application.answers.filter((x) => x.questionType === QuestionType.ForQuestionnaire)}
        updateQuestionRating={updateQuestionRatingWithValidations}
        isOpen={accordionState[3]}
        toggleAccordion={() => toggleAccordion(3)}
      />
    </div>
  );
};

export default ApplicationDisplay;
